import React from 'react'
import "../components/GC_Testimonials.css";

const testimonials = [
  {comments: "“Robustik completely transformed how our business looks online. They understood what we were trying to communicate, rebuilt the website around that, and made the whole experience feel much more professional.", author:"Ethan Miller", designation: "Founder, Northlane Home Services", picURL:"/assets/img/testimonials/1.png"},

  {comments: "We worked with Robustik on our website and brand presentation. They were responsive throughout the project, paid attention to the smaller details, and delivered a design that actually feels aligned with our company.", author:"Rachel Thompson", designation: "Marketing Director, Crestline Consulting", picURL:""},

  {comments: "What I appreciated most about working with Robustik was that they didn’t just focus on making the website look good. They thought about usability, messaging, and how visitors would actually move through the site.", author:"Aaliyah Warren", designation: "Co-Founder, BrightStone Solutions", picURL:""},

  {comments: "Our previous website felt dated and difficult to navigate. Robustik gave it a much cleaner structure and a more modern look without overcomplicating things. Communication was smooth and we’re very happy with the final result.", author:"Amanda Brooks", designation: "Operations Manager, Elevate Property Group", picURL:""},

  {comments: "We hired Robustik for web development and UI improvements, and they were excellent to work with. Everything was delivered professionally and the site performs noticeably better now.", author:"Devon Cross", designation: "CEO, Vertex Business Systems", picURL:""},


];

const GC_Testimonials = () => {
  return (
    <section className="testimonials">
      <div className='container m-0'>
        <div className="heading-wrapper flex flex-col xl:flex-row align-middle justify-between mt-20">
          <div className="w-full xl:w-1/2 hh3 ">
            Don’t take our words for it
            Hear it from <span className="text-primary font-medium">Our Customers</span>
          </div>

          <div className="w-full xl:w-1/3 flex ">
            <p>Our clients feedback reflects our commitment to quality, innovation, and collaboration.</p>
          </div>

        </div>
      
        
        <div className="scene">
          <div className="carousel">
             {
             testimonials.map((testimonial, index) => (
              <div key={index} className="item">
                <div className="fs-20">
                  {testimonial.comments}
                </div>

                <div className="flex gap-2 ">
                  
                  <div className="profile-pic" >{testimonial.picURL === "" ? testimonial.author.charAt(0)  : <img src={testimonial.picURL} alt={testimonial.author} max-width="72" max-height="83" />  }</div>
                  <div className='flex flex-col justify-center'> 
                    <div className="text-primary fs-20 font-bolder">{testimonial.author}</div>
                    <p className="font-extralight m-0 fs-12">{testimonial.designation}</p>
                  </div>
                </div>


                
              </div>

             ))
            }
            
              {/* <div className="item">
               
                <div>
                  <div>
                    
                  </div>
                  <div>

                  </div>
                </div>
              </div>
              <div className="item">2</div>
              <div className="item">3</div>
              <div className="item">4</div>
              <div className="item">5</div> */}
          </div>
        </div>
      </div>
    </section>
  )
}

export default GC_Testimonials
